module.exports = __webpack_public_path__ + "static/media/list.643f65f0.svg";